/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadWarningDetails
 */
export interface LeadWarningDetails {
    /**
     * 
     */
    limit_name?: string;
    /**
     * 
     */
    limit_value?: number;
    /**
     * 
     */
    actual_value?: number;
}

/**
 * Check if a given object implements the LeadWarningDetails interface.
 */
export function instanceOfLeadWarningDetails(value: object): value is LeadWarningDetails {
    return true;
}

export function LeadWarningDetailsFromJSON(json: any): LeadWarningDetails {
    return LeadWarningDetailsFromJSONTyped(json, false);
}

export function LeadWarningDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadWarningDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'limit_name': json['limit_name'] == null ? undefined : json['limit_name'],
        'limit_value': json['limit_value'] == null ? undefined : json['limit_value'],
        'actual_value': json['actual_value'] == null ? undefined : json['actual_value'],
    };
}

export function LeadWarningDetailsToJSON(json: any): LeadWarningDetails {
    return LeadWarningDetailsToJSONTyped(json, false);
}

export function LeadWarningDetailsToJSONTyped(value?: LeadWarningDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'limit_name': value['limit_name'],
        'limit_value': value['limit_value'],
        'actual_value': value['actual_value'],
    };
}

